module.exports = __webpack_public_path__ + "static/img/face_error3.335f6fd8.jpg";